module.exports = __webpack_public_path__ + "static/media/Voyager-RE-4600-IQ.98c415c2.png";